export enum DeepLinkEvent {
  Cancel = 'tem::cancel',
  Success = 'tem::success',
}
